import {
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const coaFilterList = (permissions) => {
  const defaultFilter = [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <NumberInput
      alwaysOn
      source="code"
      label="mine.label.code"
      variant="outlined"
    />,
    <TextInput
      alwaysOn
      source="name"
      label="mine.label.name"
      resettable
      variant="outlined"
    />,
    <NumberInput
      alwaysOn
      source="class"
      label="mine.label.class"
      variant="outlined"
    />,
    <SelectInput
      alwaysOn
      source="nature"
      label="mine.label.nature"
      variant="outlined"
      choices={[
        { id: "D", name: "Debit" },
        { id: "C", name: "Credit" },
      ]}
    />,
    <NumberInput
      alwaysOn
      source="parent"
      label="mine.label.parent"
      variant="outlined"
    />,
    <NumberInput alwaysOn source="level" variant="outlined" />,
    <SelectInput
      alwaysOn
      source="type"
      label="mine.label.type"
      variant="outlined"
      choices={[
        { id: "G", name: "General" },
        { id: "D", name: "Detail" },
      ]}
    />,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default coaFilterList;
